import { AlertFloating, Button, Input } from "@light-technology/components";
import { Mail01 } from "@untitledui/icons";
import { api } from "../../state/api";
import { type Account } from "../../state/api.types";
import { FormCard } from "../shared/FormCard";
import { ChangeEmailModal } from "./ChangeEmailModal";

type EmailCardProps = {
  account: Account;
};

export const EmailCard = ({ account }: EmailCardProps) => {
  const [cancelEmailUpdate] = api.useCancelEmailUpdateMutation();

  return (
    <FormCard
      name="Email"
      customButton={
        <ChangeEmailModal account={account}>
          <Button color="primary" size="md">
            Change Email
          </Button>
        </ChangeEmailModal>
      }
    >
      <Input
        value={account.email}
        type="email"
        isDisabled
        icon={Mail01}
        aria-label="Email"
      />
      {account.pending_email && !account.pending_email_error && (
        <div className="mt-sm text-sm text-tertiary">
          Accept the verification email sent to {account.pending_email} to
          complete the update.
        </div>
      )}
      {account.pending_email_error && account.pending_email && (
        <div className="mt-md">
          <AlertFloating
            color="error"
            description={`We were unable to send a verification email to ${account.pending_email}. Please check that the email is correct and try again.`}
            onClose={() => {
              cancelEmailUpdate(null);
            }}
            showDismiss={false}
            truncateDescription={false}
          />
        </div>
      )}
    </FormCard>
  );
};
